export default {"src":"https://search.testwiggot.com/_next/static/media/asterisk.3523ed58.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};